import ReportTable, { RRow, RCell } from "components/Tables/ReportTable";
import { Box, useTheme, Grid, Button, InputBase, Paper } from "@mui/material";
import SupplierForm from "../forms/supplierForm";
import ResponsiveDialog from "components/responsiveDialog";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useSupplierList } from "api/hooks/inventory";
import { requester } from "api/pesabackend";
import SearchIcon from "@mui/icons-material/Search";
import IconButton from "@mui/material/IconButton";

const columns = [
  { label: "No." },
  { label: "Supplier Name" },
  { label: "Contact" },
  { label: "Location" },
  { label: "Actions", align: "center" },
];

export default function Suppliers({ setIsSuccess }) {
  const theme = useTheme();
  const business_branch_id = useSelector((state) => state.authReducer.business_branch_id);
  const { supplierList, isLoadingSupplierList, setNewSupplierData, setSearch } = useSupplierList(1, business_branch_id);
  const [open, setOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [editData, setEditData] = useState({ name: "", mobile: "", address: "" });
  const [clickedItem, setClickedItem] = useState("");
  const [searchContent, setSearchContent] = useState("");

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickEditOpen = async (e) => {
    setClickedItem(e.target.value);
    const response = await requester.get(`/inventory/suppliers/get/${e.target.value}`);
    setEditData(response.data.data);
    setOpenEdit(true);
  };

  const handleClickEditClose = () => {
    setOpenEdit(false);
  };

  const handleClickDeleteOpen = async (e) => {
    setClickedItem(e.target.value);
    await requester.get(`/inventory/suppliers/get/${e.target.value}`);
    setOpenDelete(true);
  };

  const handleClickDeleteClose = () => {
    setOpenDelete(false);
  };

  const handleClickDelete = async () => {
    if (isDeleting) return;
    setIsDeleting(true);
    await requester.post(`/inventory/suppliers/delete/${clickedItem}`);
    setIsSuccess(true);
    setNewSupplierData(true);
    setIsDeleting(false);
    setOpenDelete(false);
  };

  const handleSearchInput = async (e) => {
    setSearchContent(e.target.value);
  };

  const handleClickSearch = async () => {
    setSearch(searchContent);
  };

  return (
    <Box>
      <h4>Supplier List</h4>
      <Box p="1rem" m="1rem" borderRadius="0.5rem">
        <Grid container spacing={4} className="alignHorizantal">
          <Grid xs>
            <Paper
              sx={{ my: "4px", p: "2px 4px", display: "flex", alignItems: "center", minWidth: 170, maxWidth: 300 }}
            >
              <InputBase
                placeholder="Search Supplier"
                value={searchContent}
                onChange={handleSearchInput}
                sx={{ ml: 1, flex: 1 }}
              />
              <IconButton onClick={handleClickSearch}>
                <SearchIcon />
              </IconButton>
            </Paper>
          </Grid>
          <Grid xs></Grid>
          <Grid xs sx={{ textAlign: "right" }}>
            <Button variant="contained" onClick={handleClickOpen}>Add Supplier</Button>
            <ResponsiveDialog
              dialogButtonName="Add Supplier"
              dialogHeading="Add a New Supplier"
              open={open}
              handleClickOpen={handleClickOpen}
              handleClose={handleClose}
              negativeResponse="Cancel"
              positiveResponse="Save"
              content={
                <Box p="1rem" borderRadius="0.5rem" backgroundColor={theme.palette.background.alt}>
                  <SupplierForm
                    formType="create"
                    setOpen={setOpen}
                    setNewSupplierData={setNewSupplierData}
                    setIsSuccess={setIsSuccess}
                    editData={editData}
                  />
                </Box>
              }
            />
          </Grid>
        </Grid>
      </Box>

      <ReportTable
        columns={columns}
        rows={supplierList}
        loading={isLoadingSupplierList}
        emptyMessage="No data found"
        renderRow={(row, index) => (
          <RRow key={row.id} index={index}>
            <RCell>{index + 1}</RCell>
            <RCell>{row.name}</RCell>
            <RCell>{row.mobile}</RCell>
            <RCell>{row.address}</RCell>
            <RCell align="center">
              <Button value={row.id} size="small" onClick={handleClickEditOpen}>Edit</Button>
              <Button value={row.id} size="small" onClick={handleClickDeleteOpen}>Delete</Button>
            </RCell>
          </RRow>
        )}
      />

      <ResponsiveDialog
        dialogHeading="Edit"
        open={openEdit}
        handleClose={handleClickEditClose}
        negativeResponse="Cancel"
        content={
          <Box p="1rem" borderRadius="0.5rem" backgroundColor={theme.palette.background.alt}>
            <SupplierForm
              formType="edit"
              id={clickedItem}
              editData={editData}
              setOpen={setOpenEdit}
              setNewSupplierData={setNewSupplierData}
              setIsSuccess={setIsSuccess}
            />
          </Box>
        }
      />

      <ResponsiveDialog
        dialogHeading="Are you sure you want to delete?"
        open={openDelete}
        handleClose={handleClickDeleteClose}
        negativeResponse="Cancel"
        content={
          <Box p="1rem" borderRadius="0.5rem" backgroundColor={theme.palette.background.alt}>
            <Button
              fullWidth
              type="submit"
              variant="contained"
              disabled={isDeleting}
              onClick={handleClickDelete}
              sx={{ m: "1rem 0", p: "1rem" }}
            >
              Yes, Delete
            </Button>
          </Box>
        }
      />
    </Box>
  );
}
